import { Estimate, EstimateAcceptResponse, EstimateExtras } from "./estimate";
import {
  EstimateAcceptSuccessActionType,
  EstimateAction,
  EstimateCreateActionType,
  EstimateGetSuccessActionType,
  EstimateSaveExtrasActionType,
  EstimateUpdateNoMatchCountActionType,
  EstimateUpdateRepaymentActionType,
} from "./estimate.actions";

const initialState = {
  noMatchCount: 0,
};

export const estimateReducer = (
  state: EstimateState = initialState,
  action: EstimateAction
) => {
  switch (action.type) {
    case EstimateCreateActionType:
      return { ...initialState, noMatchCount: state.noMatchCount };

    case EstimateSaveExtrasActionType:
      return {
        ...state,
        extras: action.extras,
      };

    case EstimateGetSuccessActionType:
      return {
        ...state,
        estimate: action.estimate,
      };

    case EstimateUpdateRepaymentActionType:
      return {
        ...state,
        estimate: action.estimate,
      };

    case EstimateUpdateNoMatchCountActionType:
      return {
        ...state,
        noMatchCount: state.noMatchCount + 1,
      };

    case EstimateAcceptSuccessActionType:
      return {
        ...state,
        estimateAcceptResponse: action.estimateAcceptResponse,
      };

    default:
      return state;
  }
};

export interface EstimateState {
  estimate?: Estimate;
  extras?: EstimateExtras;
  estimateAcceptResponse?: EstimateAcceptResponse;
  noMatchCount: number;
}
